export default {
  login: "Akupsmee",
  id: 62156533,
  node_id: "MDQ6VXNlcjYyMTU2NTMz",
  avatar_url: "https://avatars.githubusercontent.com/u/62156533?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/Akupsmee",
  html_url: "https://github.com/Akupsmee",
  followers_url: "https://api.github.com/users/Akupsmee/followers",
  following_url: "https://api.github.com/users/Akupsmee/following{/other_user}",
  gists_url: "https://api.github.com/users/Akupsmee/gists{/gist_id}",
  starred_url: "https://api.github.com/users/Akupsmee/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/Akupsmee/subscriptions",
  organizations_url: "https://api.github.com/users/Akupsmee/orgs",
  repos_url: "https://api.github.com/users/Akupsmee/repos",
  events_url: "https://api.github.com/users/Akupsmee/events{/privacy}",
  received_events_url: "https://api.github.com/users/Akupsmee/received_events",
  type: "User",
  site_admin: false,
  name: "Ikenna Blaise Akupuome",
  company: "University of Bremen",
  blog: "",
  location: "Bremen, Germany",
  email: null,
  hireable: null,
  bio: "Front-End Developer ",
  twitter_username: "Akupsmee",
  public_repos: 19,
  public_gists: 0,
  followers: 0,
  following: 0,
  created_at: "2020-03-13T19:13:02Z",
  updated_at: "2021-06-06T08:28:08Z",
};
